import type { BuilderPropertyRecord } from '../tool-defaults';
import { LabeledNumberRow, LabeledSelectRow } from './field-primitives';

export type SigFigUiMode = 'Not required' | 'Require same as the answer' | 'Require N or fewer';

export function sigFigUiModeFromProps(p: { require_sig_fig: boolean; require_n_or_fewer_sig_figs: number }): SigFigUiMode {
    const n = p.require_n_or_fewer_sig_figs;
    if (!p.require_sig_fig && n === 0) {
        return 'Not required';
    }
    if (p.require_sig_fig && n === 0) {
        return 'Require same as the answer';
    }
    return 'Require N or fewer';
}

export function patchForSigFigUiMode(mode: SigFigUiMode): BuilderPropertyRecord {
    switch (mode) {
        case 'Not required':
            return { require_n_or_fewer_sig_figs: 0, require_sig_fig: false };
        case 'Require same as the answer':
            return { require_n_or_fewer_sig_figs: 0, require_sig_fig: true };
        case 'Require N or fewer':
            return { require_n_or_fewer_sig_figs: 3, require_sig_fig: false };
        default:
            return {};
    }
}

export function SignificantFiguresControls({
    mode,
    requireNOrFewer,
    onPatch,
}: {
    mode: SigFigUiMode;
    requireNOrFewer: number;
    onPatch: (patch: BuilderPropertyRecord) => void;
}) {
    const showN = mode === 'Require N or fewer';

    return (
        <div className="space-y-3">
            <LabeledSelectRow
                label="Significant figures"
                value={mode}
                options={['Not required', 'Require same as the answer', 'Require N or fewer']}
                onValueChange={next => {
                    onPatch(patchForSigFigUiMode(next as SigFigUiMode));
                }}
            />
            {showN ? (
                <LabeledNumberRow
                    label="N"
                    placeholder="Ex: 3"
                    value={requireNOrFewer}
                    onIntChange={n => onPatch({ require_n_or_fewer_sig_figs: n })}
                />
            ) : null}
        </div>
    );
}
